import { render, staticRenderFns } from "./LkNavbarItem.vue?vue&type=template&id=b26f5a38&"
import script from "./LkNavbarItem.vue?vue&type=script&lang=js&"
export * from "./LkNavbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports